import { useEffect, useState } from 'react';
import './RatingStars.css';
import api from 'shared/functions/api';


interface RatingStarsProps {
  userId: string;
  onLoading?: (loading: boolean) => void;
  onError?: () => void;
}

export const RatingStars = ({ userId, onLoading, onError }: RatingStarsProps) => {
  const [rating, setRating] = useState<number>(0);
  const [hoverRating, setHoverRating] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(userId ? true : false);

  console.log('RatingStars component mounted with userId:', userId);

  // Cargar el rating del usuario cuando userId está disponible
  useEffect(() => {
    if (!userId) {
      setIsLoading(false);
      onLoading && onLoading(false);
      return;
    }
    setIsLoading(true);
    onLoading && onLoading(true);
    const loadUserRating = async () => {
      try {
        const jwt = localStorage.getItem('jwt') || '';
        const userFeedback = await api.getUserFeedback(jwt, userId);
        if (userFeedback) {
          setRating(userFeedback.rating);
        } else {
          setRating(0);
        }
      } catch (error) {
        setRating(0);
        onError && onError();
      } finally {
        setIsLoading(false);
        onLoading && onLoading(false);
      }
    };
    loadUserRating();
  }, [userId, onLoading, onError]);

  const handleStarClick = async (starValue: number) => {
    console.log('Star clicked:', starValue, 'current userId:', userId, 'current rating:', rating);
    
    // Use the passed userId, not just check if it exists
    if (!userId || userId.trim() === '') {
      console.log('Cannot rate - userId is empty or whitespace');
      return;
    }
    
    try {
      console.log('Attempting to save rating:', starValue, 'for userId:', userId);
      setRating(starValue);
      const jwt = localStorage.getItem('jwt') || '';
      console.log('JWT token exists:', !!jwt);
      
      if (!jwt) {
        console.error('No JWT token found');
        setRating(rating); // revert
        return;
      }
      
      const result = await api.saveUserFeedback(jwt, userId, starValue);
      console.log('Feedback saved successfully:', result);
    } catch (error) {
      console.error('Error saving feedback:', error);
      // Revert on error
      setRating(rating);
    }
  };

  return (
    <div className="rating-stars-container">
      <div className="rating-stars-wrapper">
        {[1, 2, 3, 4, 5].map((starValue) => {
          const isDisabled = !userId || userId.trim() === '';
          return (
            <button
              key={starValue}
              className={`star ${starValue <= (hoverRating || rating) ? 'active' : ''} ${isDisabled ? 'disabled-state' : ''}`}
              onClick={() => handleStarClick(starValue)}
              onMouseEnter={() => !isDisabled && setHoverRating(starValue)}
              onMouseLeave={() => setHoverRating(0)}
              aria-label={`Rate ${starValue} stars`}
              type="button"
            >
              ★
            </button>
          );
        })}
      </div>
    </div>
  );
};
